import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../../components/feature/LanguageToggle';

export default function MauritransShippingPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const services = [
    { icon: 'ri-ship-line', titleKey: 'mau_svc1_title', descKey: 'mau_svc1_desc' },
    { icon: 'ri-anchor-line', titleKey: 'mau_svc2_title', descKey: 'mau_svc2_desc' },
    { icon: 'ri-service-line', titleKey: 'mau_svc3_title', descKey: 'mau_svc3_desc' },
    { icon: 'ri-truck-line', titleKey: 'mau_svc4_title', descKey: 'mau_svc4_desc' },
    { icon: 'ri-box-3-line', titleKey: 'mau_svc5_title', descKey: 'mau_svc5_desc' },
    { icon: 'ri-plane-line', titleKey: 'mau_svc6_title', descKey: 'mau_svc6_desc' },
    { icon: 'ri-file-list-3-line', titleKey: 'mau_svc7_title', descKey: 'mau_svc7_desc' },
    { icon: 'ri-building-4-line', titleKey: 'mau_svc8_title', descKey: 'mau_svc8_desc' },
    { icon: 'ri-roadster-line', titleKey: 'mau_svc9_title', descKey: 'mau_svc9_desc' },
  ];

  const whyItems = [
    { icon: 'ri-time-line', titleKey: 'mau_why1_title', descKey: 'mau_why1_desc' },
    { icon: 'ri-shield-check-line', titleKey: 'mau_why2_title', descKey: 'mau_why2_desc' },
    { icon: 'ri-global-line', titleKey: 'mau_why3_title', descKey: 'mau_why3_desc' },
    { icon: 'ri-customer-service-2-line', titleKey: 'mau_why4_title', descKey: 'mau_why4_desc' },
    { icon: 'ri-price-tag-3-line', titleKey: 'mau_why5_title', descKey: 'mau_why5_desc' },
    { icon: 'ri-map-pin-line', titleKey: 'mau_why6_title', descKey: 'mau_why6_desc' },
    { icon: 'ri-dashboard-line', titleKey: 'mau_why7_title', descKey: 'mau_why7_desc' },
    { icon: 'ri-file-shield-2-line', titleKey: 'mau_why8_title', descKey: 'mau_why8_desc' },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/08e651986c1a2c862c6b7b398d1365c8.jpeg" alt="GDSATLAS Logo" className="h-12 w-auto" />
            </Link>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('mau_nav_home')}</Link>
              <Link to="/compass-resources" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('mau_nav_compass')}</Link>
              <a href="#services" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('mau_nav_services')}</a>
              <a href="#about" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('mau_nav_about')}</a>
              <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('mau_nav_contact')}</a>
              <LanguageToggle />
              <a href="#contact" className="px-6 py-2 border-2 border-[#D4AF37] text-[#D4AF37] rounded-full text-sm font-semibold hover:bg-[#D4AF37] hover:text-[#0A1F44] transition-all whitespace-nowrap">
                {t('mau_nav_quote')}
              </a>
            </div>
            <button className="md:hidden cursor-pointer" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <i className="ri-menu-line text-2xl text-gray-700"></i>
            </button>
          </div>
          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('mau_nav_home')}</Link>
              <Link to="/compass-resources" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('mau_nav_compass')}</Link>
              <a href="#services" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('mau_nav_services')}</a>
              <a href="#about" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('mau_nav_about')}</a>
              <a href="#contact" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('mau_nav_contact')}</a>
              <LanguageToggle className="mt-2" />
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/0902ab0aa661944ea11cd78786a80512.jpg"
            alt="Mauritrans Shipping"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44]/85 via-[#0A1F44]/75 to-[#0A1F44]/85"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
          <div className="inline-flex items-center px-6 py-2 bg-[#0A1F44]/60 backdrop-blur-sm rounded-full mb-8">
            <i className="ri-ship-line text-[#D4AF37] text-lg mr-2"></i>
            <span className="text-white text-sm font-medium">{t('mau_hero_badge')}</span>
          </div>
          <div className="mb-8 flex justify-center">
            <div className="inline-block bg-white/95 backdrop-blur-sm px-8 py-4 rounded-2xl">
              <img src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/6ccaa6d0175bf43f4647618f6ac0b19b.png" alt="Mauritrans Shipping Logo" className="h-20 w-auto" />
            </div>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('mau_hero_title').split('\n').map((line, i) => (
              <span key={i}>{line}{i === 0 && <br />}</span>
            ))}
          </h2>
          <p className="text-xl text-gray-200 mb-12 max-w-3xl mx-auto">{t('mau_hero_subtitle')}</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <p className="text-[#D4AF37] text-3xl font-bold">500+</p>
              <p className="text-white/80 text-sm">{t('mau_hero_stat1_label')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <p className="text-[#D4AF37] text-3xl font-bold">9</p>
              <p className="text-white/80 text-sm">{t('mau_hero_stat2_label')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <p className="text-[#D4AF37] text-3xl font-bold">{t('mau_hero_stat3')}</p>
              <p className="text-white/80 text-sm">{t('mau_hero_stat3_label')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <p className="text-[#D4AF37] text-3xl font-bold">{t('mau_hero_stat4')}</p>
              <p className="text-white/80 text-sm">{t('mau_hero_stat4_label')}</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#services" className="px-8 py-4 bg-[#D4AF37] text-[#0A1F44] rounded-full text-base font-semibold hover:bg-[#C4A037] transition-all flex items-center whitespace-nowrap">
              {t('mau_hero_cta1')}
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a href="#contact" className="px-8 py-4 border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white hover:text-[#0A1F44] transition-all whitespace-nowrap">
              {t('mau_hero_cta2')}
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20logistics%20team%20coordinating%20cargo%20operations%20at%20modern%20port%20facility%2C%20diverse%20workers%20in%20safety%20gear%20managing%20containers%2C%20contemporary%20warehouse%20with%20organized%20inventory%2C%20efficient%20supply%20chain%20management%2C%20professional%20industrial%20photography%20with%20natural%20lighting%2C%20teamwork%20and%20precision%20in%20maritime%20logistics%20operations&width=800&height=900&seq=mauritrans-about-001&orientation=portrait"
                  alt="Mauritrans Operations"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div>
              <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-6">
                <span className="text-[#0A1F44] text-sm font-semibold">{t('mau_about_tag')}</span>
              </div>
              <h2 className="text-5xl font-bold text-[#0A1F44] mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                {t('mau_about_title').split('\n').map((line, i) => (
                  <span key={i}>{line}{i === 0 && <br />}</span>
                ))}
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">{t('mau_about_p1')}</p>
              <p className="text-gray-600 text-base leading-relaxed mb-8">{t('mau_about_p2')}</p>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white border-l-4 border-[#D4AF37] p-4 rounded-lg">
                  <p className="text-[#0A1F44] font-bold text-2xl mb-1">{t('mau_about_stat1')}</p>
                  <p className="text-gray-600 text-sm">{t('mau_about_stat1_label')}</p>
                </div>
                <div className="bg-white border-l-4 border-[#D4AF37] p-4 rounded-lg">
                  <p className="text-[#0A1F44] font-bold text-2xl mb-1">{t('mau_about_stat2')}</p>
                  <p className="text-gray-600 text-sm">{t('mau_about_stat2_label')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-4">
              <span className="text-[#0A1F44] text-sm font-semibold">{t('mau_svc_tag')}</span>
            </div>
            <h2 className="text-5xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t('mau_svc_title')}</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">{t('mau_svc_subtitle')}</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-[#F8F9FA] border border-gray-200 rounded-3xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
                <div className="w-16 h-16 bg-[#0A1F44] rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-[#D4AF37] text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#0A1F44] mb-4">{t(service.titleKey)}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{t(service.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-4">
              <span className="text-[#0A1F44] text-sm font-semibold">{t('mau_why_tag')}</span>
            </div>
            <h2 className="text-5xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t('mau_why_title')}</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">{t('mau_why_subtitle')}</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyItems.map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 hover:shadow-lg transition-all duration-300">
                <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-[#D4AF37] text-xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#0A1F44] mb-2">{t(item.titleKey)}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{t(item.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trusted Clients Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-4">
              <span className="text-[#0A1F44] text-sm font-semibold">{t('mau_clients_tag')}</span>
            </div>
            <h2 className="text-4xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t('mau_clients_title')}</h2>
            <p className="text-gray-600 text-base max-w-2xl mx-auto">{t('mau_clients_subtitle')}</p>
          </div>
          <div className="bg-[#F8F9FA] rounded-3xl p-10">
            <img
              src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/79c6a029525ac97b5d2aa9d45f291de1.jpeg"
              alt="Mauritrans Shipping Trusted Clients"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="mt-8 text-center">
            <p className="text-gray-500 text-sm">
              {t('mau_clients_note')} <strong className="text-[#0A1F44]">Orange, Petronas, Tullow Oil, Somelec, Kinross, Tasiast, Kosmos Energy</strong> {t('mau_clients_note2')}
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20busy%20container%20port%20at%20sunset%2C%20massive%20cargo%20ships%20docked%20at%20modern%20terminal%2C%20organized%20rows%20of%20colorful%20shipping%20containers%2C%20efficient%20port%20operations%2C%20golden%20hour%20lighting%20over%20maritime%20logistics%20hub%2C%20professional%20industrial%20photography%20showing%20scale%20and%20efficiency%2C%20international%20trade%20infrastructure%2C%20warm%20atmospheric%20lighting&width=1920&height=800&seq=mauritrans-cta-001&orientation=landscape"
            alt="Port Operations"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#001E3C]/85"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-6xl md:text-7xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('mau_cta_title').split('\n').map((line, i) => (
              <span key={i}>{line}{i === 0 && <br />}</span>
            ))}
          </h2>
          <p className="text-white/90 text-xl mb-12 max-w-3xl mx-auto leading-relaxed">
            {t('mau_cta_subtitle').split('\n').map((line, i) => (
              <span key={i}>{line}{i === 0 && <br />}</span>
            ))}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#contact" className="inline-flex items-center px-8 py-4 bg-[#D4AF37] text-[#0A1F44] rounded-full text-base font-semibold hover:bg-[#C4A037] transition-all whitespace-nowrap">
              {t('mau_cta_btn1')}
              <div className="ml-3 w-8 h-8 bg-[#0A1F44] rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </div>
            </a>
            <a href="https://wa.me/22244290990" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white hover:text-[#0A1F44] transition-all whitespace-nowrap">
              <i className="ri-whatsapp-line mr-2"></i>
              {t('mau_cta_btn2')}
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-4">
              <span className="text-[#0A1F44] text-sm font-semibold">{t('mau_contact_tag')}</span>
            </div>
            <h2 className="text-5xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t('mau_contact_title')}</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">{t('mau_contact_subtitle')}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('mau_contact_addr_label')}</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">ZRF ND F Nord Sect1 - 444<br />Tevragh Zeina<br />Nouakchott – Mauritanie</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('mau_contact_phone_label')}</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">+(222) 46427000<br />+(222) 44290990</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('mau_contact_email_label')}</h4>
                    <p className="text-gray-600 text-sm">contact@gds-atlas.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-building-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('mau_contact_parent_label')}</h4>
                    <Link to="/" className="text-[#D4AF37] text-sm hover:underline">GDSATLAS Holding</Link>
                  </div>
                </div>
                <div className="bg-[#FFF9F0] border-l-4 border-[#D4AF37] p-6 rounded-lg">
                  <p className="text-[#0A1F44] font-medium text-sm leading-relaxed">
                    <strong>Mauritrans Shipping</strong> — {t('mau_contact_note')}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#F8F9FA] rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-[#0A1F44] mb-6">{t('mau_form_title')}</h3>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('mau_form_company')}</label>
                  <input type="text" className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" placeholder={t('mau_form_company_ph')} />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{t('mau_form_name')}</label>
                    <input type="text" className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" placeholder={t('mau_form_name_ph')} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{t('mau_form_email')}</label>
                    <input type="email" className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" placeholder={t('mau_form_email_ph')} />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('mau_form_service')}</label>
                  <select className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm cursor-pointer">
                    <option>{t('mau_form_service_ph')}</option>
                    <option>{t('mau_form_svc_opt1')}</option>
                    <option>{t('mau_form_svc_opt2')}</option>
                    <option>{t('mau_form_svc_opt3')}</option>
                    <option>{t('mau_form_svc_opt4')}</option>
                    <option>{t('mau_form_svc_opt5')}</option>
                    <option>{t('mau_form_svc_opt6')}</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('mau_form_message')}</label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm resize-none" placeholder={t('mau_form_message_ph')}></textarea>
                </div>
                <button type="submit" className="w-full px-8 py-4 bg-[#D4AF37] text-[#0A1F44] rounded-full text-base font-semibold hover:bg-[#C4A037] transition-all whitespace-nowrap cursor-pointer">
                  {t('mau_form_submit')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1F44] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <img src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/6ccaa6d0175bf43f4647618f6ac0b19b.png" alt="Mauritrans Shipping Logo" className="h-12 w-auto mb-6" />
              <p className="text-white/70 text-sm mb-6 leading-relaxed">{t('mau_footer_tagline')}</p>
              <p className="text-white/50 text-xs mb-6">{t('mau_footer_subsidiary')}</p>
              <Link to="/" className="inline-flex items-center text-[#D4AF37] text-sm hover:underline">
                <i className="ri-arrow-left-line mr-2"></i>
                {t('mau_footer_back')}
              </Link>
            </div>
            <div>
              <h4 className="text-[#D4AF37] text-sm font-bold mb-4">{t('mau_footer_links')}</h4>
              <ul className="space-y-3">
                <li><a href="#services" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('mau_footer_services')}</a></li>
                <li><a href="#about" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('mau_footer_about')}</a></li>
                <li><a href="#contact" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('mau_footer_contact')}</a></li>
              </ul>
              <h4 className="text-[#D4AF37] text-sm font-bold mb-4 mt-8">{t('mau_footer_group')}</h4>
              <ul className="space-y-3">
                <li><Link to="/" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">GDSATLAS Holding</Link></li>
                <li><Link to="/compass-resources" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">Compass Resources</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-[#D4AF37] text-sm font-bold mb-4">{t('mau_contact_tag')}</h4>
              <ul className="space-y-3">
                <li className="flex items-start text-white/70 text-sm"><i className="ri-phone-line text-[#D4AF37] mr-2 mt-1"></i><span>+(222) 46427000</span></li>
                <li className="flex items-start text-white/70 text-sm"><i className="ri-mail-line text-[#D4AF37] mr-2 mt-1"></i><span>contact@gds-atlas.com</span></li>
                <li className="flex items-start text-white/70 text-sm"><i className="ri-map-pin-line text-[#D4AF37] mr-2 mt-1"></i><span>Nouakchott, Mauritanie</span></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-white/50 text-sm mb-4 md:mb-0">{t('mau_footer_copyright')}</p>
              <div className="flex items-center space-x-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center text-[#D4AF37] hover:bg-white/10 rounded-full transition-all"><i className="ri-linkedin-fill text-xl"></i></a>
                <a href="#" className="w-10 h-10 flex items-center justify-center text-[#D4AF37] hover:bg-white/10 rounded-full transition-all"><i className="ri-twitter-fill text-xl"></i></a>
                <a href="#" className="w-10 h-10 flex items-center justify-center text-[#D4AF37] hover:bg-white/10 rounded-full transition-all"><i className="ri-facebook-fill text-xl"></i></a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/22244290990"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center hover:bg-[#1ebe5d] hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="Chat on WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>
    </div>
  );
}
